export default [
    {
        "mask": "+247-0000",
        "startsWith": "247",
        "lazy": false,
        "country": "AC"
    },
    {
        "mask": "+376-000-000",
        "startsWith": "376",
        "lazy": false,
        "country": "AD"
    },
    {
        "mask": "+971-0-000-0000",
        "startsWith": "971",
        "lazy": false,
        "country": "AE"
    },
    {
        "mask": "+93-00-000-0000",
        "startsWith": "93",
        "lazy": false,
        "country": "AF"
    },
    {
        "mask": "+1(268)000-0000",
        "startsWith": "1268",
        "lazy": false,
        "country": "AG"
    },
    {
        "mask": "+1(264)000-0000",
        "startsWith": "1264",
        "lazy": false,
        "country": "AI"
    },
    {
        "mask": "+355(000)000-000",
        "startsWith": "355",
        "lazy": false,
        "country": "AL"
    },
    {
        "mask": "+374-00-000-000",
        "startsWith": "374",
        "lazy": false,
        "country": "AM"
    },
    {
        "mask": "+599-9000-0000",
        "startsWith": "5999",
        "lazy": false,
        "country": "AN"
    },
    {
        "mask": "+244(000)000-000",
        "startsWith": "244",
        "lazy": false,
        "country": "AO"
    },
    {
        "mask": "+672-100-000",
        "startsWith": "6721",
        "lazy": false,
        "country": "AQ"
    },
    {
        "mask": "+54(000)000-0000",
        "startsWith": "54",
        "lazy": false,
        "country": "AR"
    },
    {
        "mask": "+1(684)000-0000",
        "startsWith": "1684",
        "lazy": false,
        "country": "AS"
    },
    {
        "mask": "+43(000)000-0000",
        "startsWith": "43",
        "lazy": false,
        "country": "AT"
    },
    {
        "mask": "+61-0-0000-0000",
        "startsWith": "61",
        "lazy": false,
        "country": "AU"
    },
    {
        "mask": "+297-000-0000",
        "startsWith": "297",
        "lazy": false,
        "country": "AW"
    },
    {
        "mask": "+994-00-000-00-00",
        "startsWith": "994",
        "lazy": false,
        "country": "AZ"
    },
    {
        "mask": "+387-00-0000",
        "startsWith": "387",
        "lazy": false,
        "country": "BA"
    },
    {
        "mask": "+1(246)000-0000",
        "startsWith": "1246",
        "lazy": false,
        "country": "BB"
    },
    {
        "mask": "+880-00-000-000",
        "startsWith": "880",
        "lazy": false,
        "country": "BD"
    },
    {
        "mask": "+32(000)000-000",
        "startsWith": "32",
        "lazy": false,
        "country": "BE"
    },
    {
        "mask": "+226-00-00-0000",
        "startsWith": "226",
        "lazy": false,
        "country": "BF"
    },
    {
        "mask": "+359(000)000-000",
        "startsWith": "359",
        "lazy": false,
        "country": "BG"
    },
    {
        "mask": "+973-0000-0000",
        "startsWith": "973",
        "lazy": false,
        "country": "BH"
    },
    {
        "mask": "+257-00-00-0000",
        "startsWith": "257",
        "lazy": false,
        "country": "BI"
    },
    {
        "mask": "+229-00-00-0000",
        "startsWith": "229",
        "lazy": false,
        "country": "BJ"
    },
    {
        "mask": "+1(441)000-0000",
        "startsWith": "1441",
        "lazy": false,
        "country": "BM"
    },
    {
        "mask": "+673-000-0000",
        "startsWith": "673",
        "lazy": false,
        "country": "BN"
    },
    {
        "mask": "+591-0-000-0000",
        "startsWith": "591",
        "lazy": false,
        "country": "BO"
    },
    {
        "mask": "+55(00)90000-0000",
        "startsWith": "559",
        "lazy": false,
        "country": "BR"
    },
    {
        "mask": "+1(242)000-0000",
        "startsWith": "1242",
        "lazy": false,
        "country": "BS"
    },
    {
        "mask": "+975-0-000-000",
        "startsWith": "975",
        "lazy": false,
        "country": "BT"
    },
    {
        "mask": "+267-00-000-000",
        "startsWith": "267",
        "lazy": false,
        "country": "BW"
    },
    {
        "mask": "+375(00)000-00-00",
        "startsWith": "375",
        "lazy": false,
        "country": "BY"
    },
    {
        "mask": "+501-000-0000",
        "startsWith": "501",
        "lazy": false,
        "country": "BZ"
    },
    {
        "mask": "+1(000)000-0000",
        "startsWith": "1",
        "lazy": false,
        "country": "CA"
    },
    {
        "mask": "+243(000)000-000",
        "startsWith": "243",
        "lazy": false,
        "country": "CD"
    },
    {
        "mask": "+236-00-00-0000",
        "startsWith": "236",
        "lazy": false,
        "country": "CF"
    },
    {
        "mask": "+242-00-000-0000",
        "startsWith": "242",
        "lazy": false,
        "country": "CG"
    },
    {
        "mask": "+41-00-000-0000",
        "startsWith": "41",
        "lazy": false,
        "country": "CH"
    },
    {
        "mask": "+225-00-000-000",
        "startsWith": "225",
        "lazy": false,
        "country": "CI"
    },
    {
        "mask": "+682-00-000",
        "startsWith": "682",
        "lazy": false,
        "country": "CK"
    },
    {
        "mask": "+56-0-0000-0000",
        "startsWith": "56",
        "lazy": false,
        "country": "CL"
    },
    {
        "mask": "+237-0000-0000",
        "startsWith": "237",
        "lazy": false,
        "country": "CM"
    },
    {
        "mask": "+86-00-00000-00000",
        "startsWith": "86",
        "lazy": false,
        "country": "CN"
    },
    {
        "mask": "+57(000)000-0000",
        "startsWith": "57",
        "lazy": false,
        "country": "CO"
    },
    {
        "mask": "+506-0000-0000",
        "startsWith": "506",
        "lazy": false,
        "country": "CR"
    },
    {
        "mask": "+53-0-000-0000",
        "startsWith": "53",
        "lazy": false,
        "country": "CU"
    },
    {
        "mask": "+238(000)00-00",
        "startsWith": "238",
        "lazy": false,
        "country": "CV"
    },
    {
        "mask": "+599-000-0000",
        "startsWith": "599",
        "lazy": false,
        "country": "CW"
    },
    {
        "mask": "+357-00-000-000",
        "startsWith": "357",
        "lazy": false,
        "country": "CY"
    },
    {
        "mask": "+420(000)000-000",
        "startsWith": "420",
        "lazy": false,
        "country": "CZ"
    },
    {
        "mask": "+49-000-000",
        "startsWith": "49",
        "lazy": false,
        "country": "DE"
    },
    {
        "mask": "+253-00-00-00-00",
        "startsWith": "253",
        "lazy": false,
        "country": "DJ"
    },
    {
        "mask": "+45-00-00-00-00",
        "startsWith": "45",
        "lazy": false,
        "country": "DK"
    },
    {
        "mask": "+1(767)000-0000",
        "startsWith": "1767",
        "lazy": false,
        "country": "DM"
    },
    {
        "mask": "+1(849)000-0000",
        "startsWith": "1849",
        "lazy": false,
        "country": "DO"
    },
    {
        "mask": "+213-00-000-0000",
        "startsWith": "213",
        "lazy": false,
        "country": "DZ"
    },
    {
        "mask": "+593-0-000-0000",
        "startsWith": "593",
        "lazy": false,
        "country": "EC"
    },
    {
        "mask": "+372-000-0000",
        "startsWith": "372",
        "lazy": false,
        "country": "EE"
    },
    {
        "mask": "+20(000)000-0000",
        "startsWith": "20",
        "lazy": false,
        "country": "EG"
    },
    {
        "mask": "+291-0-000-000",
        "startsWith": "291",
        "lazy": false,
        "country": "ER"
    },
    {
        "mask": "+34(000)000-000",
        "startsWith": "34",
        "lazy": false,
        "country": "ES"
    },
    {
        "mask": "+251-00-000-0000",
        "startsWith": "251",
        "lazy": false,
        "country": "ET"
    },
    {
        "mask": "+358(000)000-00-00",
        "startsWith": "358",
        "lazy": false,
        "country": "FI"
    },
    {
        "mask": "+679-00-00000",
        "startsWith": "679",
        "lazy": false,
        "country": "FJ"
    },
    {
        "mask": "+500-00000",
        "startsWith": "500",
        "lazy": false,
        "country": "FK"
    },
    {
        "mask": "+691-000-0000",
        "startsWith": "691",
        "lazy": false,
        "country": "FM"
    },
    {
        "mask": "+298-000-000",
        "startsWith": "298",
        "lazy": false,
        "country": "FO"
    },
    {
        "mask": "+590(000)000-000",
        "startsWith": "590",
        "lazy": false,
        "country": "FR"
    },
    {
        "mask": "+241-0-00-00-00",
        "startsWith": "241",
        "lazy": false,
        "country": "GA"
    },
    {
        "mask": "+1(473)000-0000",
        "startsWith": "1473",
        "lazy": false,
        "country": "GD"
    },
    {
        "mask": "+995(000)000-000",
        "startsWith": "995",
        "lazy": false,
        "country": "GE"
    },
    {
        "mask": "+594-00000-0000",
        "startsWith": "594",
        "lazy": false,
        "country": "GF"
    },
    {
        "mask": "+233(000)000-000",
        "startsWith": "233",
        "lazy": false,
        "country": "GH"
    },
    {
        "mask": "+350-000-00000",
        "startsWith": "350",
        "lazy": false,
        "country": "GI"
    },
    {
        "mask": "+299-00-00-00",
        "startsWith": "299",
        "lazy": false,
        "country": "GL"
    },
    {
        "mask": "+220(000)00-00",
        "startsWith": "220",
        "lazy": false,
        "country": "GM"
    },
    {
        "mask": "+224-00-000-000",
        "startsWith": "224",
        "lazy": false,
        "country": "GN"
    },
    {
        "mask": "+240-00-000-0000",
        "startsWith": "240",
        "lazy": false,
        "country": "GQ"
    },
    {
        "mask": "+30(000)000-0000",
        "startsWith": "30",
        "lazy": false,
        "country": "GR"
    },
    {
        "mask": "+502-0-000-0000",
        "startsWith": "502",
        "lazy": false,
        "country": "GT"
    },
    {
        "mask": "+1(671)000-0000",
        "startsWith": "1671",
        "lazy": false,
        "country": "GU"
    },
    {
        "mask": "+245-0-000000",
        "startsWith": "245",
        "lazy": false,
        "country": "GW"
    },
    {
        "mask": "+592-000-0000",
        "startsWith": "592",
        "lazy": false,
        "country": "GY"
    },
    {
        "mask": "+852-0000-0000",
        "startsWith": "852",
        "lazy": false,
        "country": "HK"
    },
    {
        "mask": "+504-0000-0000",
        "startsWith": "504",
        "lazy": false,
        "country": "HN"
    },
    {
        "mask": "+385-00-000-000",
        "startsWith": "385",
        "lazy": false,
        "country": "HR"
    },
    {
        "mask": "+509-00-00-0000",
        "startsWith": "509",
        "lazy": false,
        "country": "HT"
    },
    {
        "mask": "+36(000)000-000",
        "startsWith": "36",
        "lazy": false,
        "country": "HU"
    },
    {
        "mask": "+62(800)000-00-000",
        "startsWith": "628",
        "lazy": false,
        "country": "ID"
    },
    {
        "mask": "+353(000)000-000",
        "startsWith": "353",
        "lazy": false,
        "country": "IE"
    },
    {
        "mask": "+972-0-000-0000",
        "startsWith": "972",
        "lazy": false,
        "country": "IL"
    },
    {
        "mask": "+91(0000)000-000",
        "startsWith": "91",
        "lazy": false,
        "country": "IN"
    },
    {
        "mask": "+246-000-0000",
        "startsWith": "246",
        "lazy": false,
        "country": "IO"
    },
    {
        "mask": "+964(000)000-0000",
        "startsWith": "964",
        "lazy": false,
        "country": "IQ"
    },
    {
        "mask": "+98(000)000-0000",
        "startsWith": "98",
        "lazy": false,
        "country": "IR"
    },
    {
        "mask": "+354-000-0000",
        "startsWith": "354",
        "lazy": false,
        "country": "IS"
    },
    {
        "mask": "+39(000)0000-000",
        "startsWith": "39",
        "lazy": false,
        "country": "IT"
    },
    {
        "mask": "+1(876)000-0000",
        "startsWith": "1876",
        "lazy": false,
        "country": "JM"
    },
    {
        "mask": "+962-0-0000-0000",
        "startsWith": "962",
        "lazy": false,
        "country": "JO"
    },
    {
        "mask": "+81(000)000-000",
        "startsWith": "81",
        "lazy": false,
        "country": "JP"
    },
    {
        "mask": "+254-000-000000",
        "startsWith": "254",
        "lazy": false,
        "country": "KE"
    },
    {
        "mask": "+996(000)000-000",
        "startsWith": "996",
        "lazy": false,
        "country": "KG"
    },
    {
        "mask": "+855-00-000-000",
        "startsWith": "855",
        "lazy": false,
        "country": "KH"
    },
    {
        "mask": "+686-00-000",
        "startsWith": "686",
        "lazy": false,
        "country": "KI"
    },
    {
        "mask": "+269-00-00000",
        "startsWith": "269",
        "lazy": false,
        "country": "KM"
    },
    {
        "mask": "+1(869)000-0000",
        "startsWith": "1869",
        "lazy": false,
        "country": "KN"
    },
    {
        "mask": "+850-0000-0000000000000",
        "startsWith": "850",
        "lazy": false,
        "country": "KP"
    },
    {
        "mask": "+82-00-000-0000",
        "startsWith": "82",
        "lazy": false,
        "country": "KR"
    },
    {
        "mask": "+965-0000-0000",
        "startsWith": "965",
        "lazy": false,
        "country": "KW"
    },
    {
        "mask": "+1(345)000-0000",
        "startsWith": "1345",
        "lazy": false,
        "country": "KY"
    },
    {
        "mask": "+7(700)000-00-00",
        "startsWith": "77",
        "lazy": false,
        "country": "KZ"
    },
    {
        "mask": "+856-00-000-000",
        "startsWith": "856",
        "lazy": false,
        "country": "LA"
    },
    {
        "mask": "+961-0-000-000",
        "startsWith": "961",
        "lazy": false,
        "country": "LB"
    },
    {
        "mask": "+1(758)000-0000",
        "startsWith": "1758",
        "lazy": false,
        "country": "LC"
    },
    {
        "mask": "+423(000)000-0000",
        "startsWith": "423",
        "lazy": false,
        "country": "LI"
    },
    {
        "mask": "+94-00-000-0000",
        "startsWith": "94",
        "lazy": false,
        "country": "LK"
    },
    {
        "mask": "+231-00-000-000",
        "startsWith": "231",
        "lazy": false,
        "country": "LR"
    },
    {
        "mask": "+266-0-000-0000",
        "startsWith": "266",
        "lazy": false,
        "country": "LS"
    },
    {
        "mask": "+370(000)00-000",
        "startsWith": "370",
        "lazy": false,
        "country": "LT"
    },
    {
        "mask": "+352(000)000-000",
        "startsWith": "352",
        "lazy": false,
        "country": "LU"
    },
    {
        "mask": "+371-00-000-000",
        "startsWith": "371",
        "lazy": false,
        "country": "LV"
    },
    {
        "mask": "+218-21-000-0000",
        "startsWith": "21821",
        "lazy": false,
        "country": "LY"
    },
    {
        "mask": "+212-00-0000-000",
        "startsWith": "212",
        "lazy": false,
        "country": "MA"
    },
    {
        "mask": "+377-00-000-000",
        "startsWith": "377",
        "lazy": false,
        "country": "MC"
    },
    {
        "mask": "+373-0000-0000",
        "startsWith": "373",
        "lazy": false,
        "country": "MD"
    },
    {
        "mask": "+382-00-000-000",
        "startsWith": "382",
        "lazy": false,
        "country": "ME"
    },
    {
        "mask": "+261-00-00-00000",
        "startsWith": "261",
        "lazy": false,
        "country": "MG"
    },
    {
        "mask": "+692-000-0000",
        "startsWith": "692",
        "lazy": false,
        "country": "MH"
    },
    {
        "mask": "+389-00-000-000",
        "startsWith": "389",
        "lazy": false,
        "country": "MK"
    },
    {
        "mask": "+223-00-00-0000",
        "startsWith": "223",
        "lazy": false,
        "country": "ML"
    },
    {
        "mask": "+95-000-000",
        "startsWith": "95",
        "lazy": false,
        "country": "MM"
    },
    {
        "mask": "+976-00-00-0000",
        "startsWith": "976",
        "lazy": false,
        "country": "MN"
    },
    {
        "mask": "+853-0000-0000",
        "startsWith": "853",
        "lazy": false,
        "country": "MO"
    },
    {
        "mask": "+1(670)000-0000",
        "startsWith": "1670",
        "lazy": false,
        "country": "MP"
    },
    {
        "mask": "+596(000)00-00-00",
        "startsWith": "596",
        "lazy": false,
        "country": "MQ"
    },
    {
        "mask": "+222-00-00-0000",
        "startsWith": "222",
        "lazy": false,
        "country": "MR"
    },
    {
        "mask": "+1(664)000-0000",
        "startsWith": "1664",
        "lazy": false,
        "country": "MS"
    },
    {
        "mask": "+356-0000-0000",
        "startsWith": "356",
        "lazy": false,
        "country": "MT"
    },
    {
        "mask": "+230-000-0000",
        "startsWith": "230",
        "lazy": false,
        "country": "MU"
    },
    {
        "mask": "+960-000-0000",
        "startsWith": "960",
        "lazy": false,
        "country": "MV"
    },
    {
        "mask": "+265-0-0000-0000",
        "startsWith": "265",
        "lazy": false,
        "country": "MW"
    },
    {
        "mask": "+52-00-00-0000",
        "startsWith": "52",
        "lazy": false,
        "country": "MX"
    },
    {
        "mask": "+60-0-000-000",
        "startsWith": "60",
        "lazy": false,
        "country": "MY"
    },
    {
        "mask": "+258-00-000-000",
        "startsWith": "258",
        "lazy": false,
        "country": "MZ"
    },
    {
        "mask": "+264-00-000-0000",
        "startsWith": "264",
        "lazy": false,
        "country": "NA"
    },
    {
        "mask": "+687-00-0000",
        "startsWith": "687",
        "lazy": false,
        "country": "NC"
    },
    {
        "mask": "+227-00-00-0000",
        "startsWith": "227",
        "lazy": false,
        "country": "NE"
    },
    {
        "mask": "+672-300-000",
        "startsWith": "6723",
        "lazy": false,
        "country": "NF"
    },
    {
        "mask": "+234(000)000-0000",
        "startsWith": "234",
        "lazy": false,
        "country": "NG"
    },
    {
        "mask": "+505-0000-0000",
        "startsWith": "505",
        "lazy": false,
        "country": "NI"
    },
    {
        "mask": "+31-00-000-0000",
        "startsWith": "31",
        "lazy": false,
        "country": "NL"
    },
    {
        "mask": "+47(000)00-000",
        "startsWith": "47",
        "lazy": false,
        "country": "NO"
    },
    {
        "mask": "+977-00-000-000",
        "startsWith": "977",
        "lazy": false,
        "country": "NP"
    },
    {
        "mask": "+674-000-0000",
        "startsWith": "674",
        "lazy": false,
        "country": "NR"
    },
    {
        "mask": "+683-0000",
        "startsWith": "683",
        "lazy": false,
        "country": "NU"
    },
    {
        "mask": "+64(000)000-0000",
        "startsWith": "64",
        "lazy": false,
        "country": "NZ"
    },
    {
        "mask": "+968-00-000-000",
        "startsWith": "968",
        "lazy": false,
        "country": "OM"
    },
    {
        "mask": "+507-000-0000",
        "startsWith": "507",
        "lazy": false,
        "country": "PA"
    },
    {
        "mask": "+51(000)000-000",
        "startsWith": "51",
        "lazy": false,
        "country": "PE"
    },
    {
        "mask": "+689-00-00-00",
        "startsWith": "689",
        "lazy": false,
        "country": "PF"
    },
    {
        "mask": "+675(000)00-000",
        "startsWith": "675",
        "lazy": false,
        "country": "PG"
    },
    {
        "mask": "+63(000)000-0000",
        "startsWith": "63",
        "lazy": false,
        "country": "PH"
    },
    {
        "mask": "+92(000)000-0000",
        "startsWith": "92",
        "lazy": false,
        "country": "PK"
    },
    {
        "mask": "+48(000)000-000",
        "startsWith": "48",
        "lazy": false,
        "country": "PL"
    },
    {
        "mask": "+970-00-000-0000",
        "startsWith": "970",
        "lazy": false,
        "country": "PS"
    },
    {
        "mask": "+351-00-000-0000",
        "startsWith": "351",
        "lazy": false,
        "country": "PT"
    },
    {
        "mask": "+680-000-0000",
        "startsWith": "680",
        "lazy": false,
        "country": "PW"
    },
    {
        "mask": "+595(000)000-000",
        "startsWith": "595",
        "lazy": false,
        "country": "PY"
    },
    {
        "mask": "+974-0000-0000",
        "startsWith": "974",
        "lazy": false,
        "country": "QA"
    },
    {
        "mask": "+262-00000-0000",
        "startsWith": "262",
        "lazy": false,
        "country": "RE"
    },
    {
        "mask": "+40-00-000-0000",
        "startsWith": "40",
        "lazy": false,
        "country": "RO"
    },
    {
        "mask": "+381-00-000-0000",
        "startsWith": "381",
        "lazy": false,
        "country": "RS"
    },
    {
        "mask": "+7(000)000-00-00",
        "startsWith": "7",
        "lazy": false,
        "country": "RU"
    },
    {
        "mask": "+7(000)000-00-00",
        "startsWith": "8",
        "lazy": false,
        "country": "RU"
    },
    {
        "mask": "+250(000)000-000",
        "startsWith": "250",
        "lazy": false,
        "country": "RW"
    },
    {
        "mask": "+966-0-000-0000",
        "startsWith": "966",
        "lazy": false,
        "country": "SA"
    },
    {
        "mask": "+677-00000",
        "startsWith": "677",
        "lazy": false,
        "country": "SB"
    },
    {
        "mask": "+248-0-000-000",
        "startsWith": "248",
        "lazy": false,
        "country": "SC"
    },
    {
        "mask": "+249-00-000-0000",
        "startsWith": "249",
        "lazy": false,
        "country": "SD"
    },
    {
        "mask": "+46-00-000-0000",
        "startsWith": "46",
        "lazy": false,
        "country": "SE"
    },
    {
        "mask": "+65-0000-0000",
        "startsWith": "65",
        "lazy": false,
        "country": "SG"
    },
    {
        "mask": "+290-0000",
        "startsWith": "290",
        "lazy": false,
        "country": "SH"
    },
    {
        "mask": "+386-00-000-000",
        "startsWith": "386",
        "lazy": false,
        "country": "SI"
    },
    {
        "mask": "+421(000)000-000",
        "startsWith": "421",
        "lazy": false,
        "country": "SK"
    },
    {
        "mask": "+232-00-000000",
        "startsWith": "232",
        "lazy": false,
        "country": "SL"
    },
    {
        "mask": "+378-0000-000000",
        "startsWith": "378",
        "lazy": false,
        "country": "SM"
    },
    {
        "mask": "+221-00-000-0000",
        "startsWith": "221",
        "lazy": false,
        "country": "SN"
    },
    {
        "mask": "+252-0-000-000",
        "startsWith": "252",
        "lazy": false,
        "country": "SO"
    },
    {
        "mask": "+597-000-000",
        "startsWith": "597",
        "lazy": false,
        "country": "SR"
    },
    {
        "mask": "+211-00-000-0000",
        "startsWith": "211",
        "lazy": false,
        "country": "SS"
    },
    {
        "mask": "+239-00-00000",
        "startsWith": "239",
        "lazy": false,
        "country": "ST"
    },
    {
        "mask": "+503-00-00-0000",
        "startsWith": "503",
        "lazy": false,
        "country": "SV"
    },
    {
        "mask": "+1(721)000-0000",
        "startsWith": "1721",
        "lazy": false,
        "country": "SX"
    },
    {
        "mask": "+963-00-0000-000",
        "startsWith": "963",
        "lazy": false,
        "country": "SY"
    },
    {
        "mask": "+268-00-00-0000",
        "startsWith": "268",
        "lazy": false,
        "country": "SZ"
    },
    {
        "mask": "+1(649)000-0000",
        "startsWith": "1649",
        "lazy": false,
        "country": "TC"
    },
    {
        "mask": "+235-00-00-00-00",
        "startsWith": "235",
        "lazy": false,
        "country": "TD"
    },
    {
        "mask": "+228-00-000-000",
        "startsWith": "228",
        "lazy": false,
        "country": "TG"
    },
    {
        "mask": "+66-00-000-000",
        "startsWith": "66",
        "lazy": false,
        "country": "TH"
    },
    {
        "mask": "+992-00-000-0000",
        "startsWith": "992",
        "lazy": false,
        "country": "TJ"
    },
    {
        "mask": "+690-0000",
        "startsWith": "690",
        "lazy": false,
        "country": "TK"
    },
    {
        "mask": "+670-780-00000",
        "startsWith": "67078",
        "lazy": false,
        "country": "TL"
    },
    {
        "mask": "+993-0-000-0000",
        "startsWith": "993",
        "lazy": false,
        "country": "TM"
    },
    {
        "mask": "+216-00-000-000",
        "startsWith": "216",
        "lazy": false,
        "country": "TN"
    },
    {
        "mask": "+676-00000",
        "startsWith": "676",
        "lazy": false,
        "country": "TO"
    },
    {
        "mask": "+90(000)000-0000",
        "startsWith": "90",
        "lazy": false,
        "country": "TR"
    },
    {
        "mask": "+1(868)000-0000",
        "startsWith": "1868",
        "lazy": false,
        "country": "TT"
    },
    {
        "mask": "+688-20000",
        "startsWith": "6882",
        "lazy": false,
        "country": "TV"
    },
    {
        "mask": "+886-0000-0000",
        "startsWith": "886",
        "lazy": false,
        "country": "TW"
    },
    {
        "mask": "+255-00-000-0000",
        "startsWith": "255",
        "lazy": false,
        "country": "TZ"
    },
    {
        "mask": "+380(00)000-00-00",
        "startsWith": "380",
        "lazy": false,
        "country": "UA"
    },
    {
        "mask": "+256(000)000-000",
        "startsWith": "256",
        "lazy": false,
        "country": "UG"
    },
    {
        "mask": "+44-00-0000-0000",
        "startsWith": "44",
        "lazy": false,
        "country": "UK"
    },
    {
        "mask": "+1(000)000-0000",
        "startsWith": "1",
        "lazy": false,
        "country": "US"
    },
    {
        "mask": "+598-0-000-00-00",
        "startsWith": "598",
        "lazy": false,
        "country": "UY"
    },
    {
        "mask": "+998-00-000-0000",
        "startsWith": "998",
        "lazy": false,
        "country": "UZ"
    },
    {
        "mask": "+39-6-698-00000",
        "startsWith": "396698",
        "lazy": false,
        "country": "VA"
    },
    {
        "mask": "+1(784)000-0000",
        "startsWith": "1784",
        "lazy": false,
        "country": "VC"
    },
    {
        "mask": "+58(000)000-0000",
        "startsWith": "58",
        "lazy": false,
        "country": "VE"
    },
    {
        "mask": "+1(284)000-0000",
        "startsWith": "1284",
        "lazy": false,
        "country": "VG"
    },
    {
        "mask": "+1(340)000-0000",
        "startsWith": "1340",
        "lazy": false,
        "country": "VI"
    },
    {
        "mask": "+84(000)0000-000",
        "startsWith": "84",
        "lazy": false,
        "country": "VN"
    },
    {
        "mask": "+678-00000",
        "startsWith": "678",
        "lazy": false,
        "country": "VU"
    },
    {
        "mask": "+681-00-0000",
        "startsWith": "681",
        "lazy": false,
        "country": "WF"
    },
    {
        "mask": "+685-00-0000",
        "startsWith": "685",
        "lazy": false,
        "country": "WS"
    },
    {
        "mask": "+967-00-000-000",
        "startsWith": "967",
        "lazy": false,
        "country": "YE"
    },
    {
        "mask": "+27-00-000-0000",
        "startsWith": "27",
        "lazy": false,
        "country": "ZA"
    },
    {
        "mask": "+260-00-000-0000",
        "startsWith": "260",
        "lazy": false,
        "country": "ZM"
    },
    {
        "mask": "+263-0-000000",
        "startsWith": "263",
        "lazy": false,
        "country": "ZW"
    },
    {
        mask: '0000000000000',
        startsWith: '',
        country: 'unknown'
    }
]
